// components/http/Actions/EstadisticasAction.js
import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene las estadísticas de la plataforma
 * @param {Function} setEstadisticas función para establecer las estadísticas
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getEstadisticas = (setEstadisticas, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Estadisticas", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'text/plain'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                setEstadisticas(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message || "Error al obtener estadísticas"); 
                reject(response.data.message || "Error al obtener estadísticas");
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Error en la respuesta del servidor"); 
                reject(error.response.data.message || "Error en la respuesta del servidor");
            } else {
                setError("Error de conexión"); 
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene la comparativa de comediantes
 */
export const getComparativaComediantes = (setComparativa, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Estadisticas/comparativa", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                setComparativa(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message || "Error al obtener comparativa");
                reject(response.data.message || "Error al obtener comparativa");
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Error en la respuesta del servidor");
                reject(error.response.data.message || "Error en la respuesta del servidor");
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene estadísticas de un video específico
 */
export const getVideoDetallado = (videoId, setVideoDetallado, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Estadisticas/video/${videoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                setVideoDetallado(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message || "Error al obtener estadísticas del video");
                reject(response.data.message || "Error al obtener estadísticas del video");
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Error en la respuesta del servidor");
                reject(error.response.data.message || "Error en la respuesta del servidor");
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene estadísticas de un evento específico
 */
export const getEventoDetallado = (eventoId, setEventoDetallado, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Estadisticas/evento/${eventoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                setEventoDetallado(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message || "Error al obtener estadísticas del evento");
                reject(response.data.message || "Error al obtener estadísticas del evento");
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Error en la respuesta del servidor");
                reject(error.response.data.message || "Error en la respuesta del servidor");
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene estadísticas generales de la plataforma
 */
export const getEstadisticasGenerales = (setEstadisticasGenerales, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Estadisticas/general", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': 'application/json'
            }
        })
        .then(response => {
            if (response.data.status === 200) {
                setEstadisticasGenerales(response.data.data);
                resolve(response.data.data);
            } else {
                setError(response.data.message || "Error al obtener estadísticas generales");
                reject(response.data.message || "Error al obtener estadísticas generales");
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message || "Error en la respuesta del servidor");
                reject(error.response.data.message || "Error en la respuesta del servidor");
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

// ======== FUNCIONES DE DESCARGA DE REPORTES ========

/**
 * Función helper para manejar descargas de PDF
 */
const downloadPDF = (response, fileName) => {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

/**
 * GET method - Descarga el informe completo de un comediante (videos + eventos)
 */
export const descargarInformeComediante = (comedianteId, fechaInicio = null, fechaFin = null, token) => {
    return new Promise((resolve, reject) => {
        let url = `/Estadisticas/comediante/${comedianteId}/pdf`;
        
        const params = new URLSearchParams();
        if (fechaInicio) {
            params.append('fechaInicio', fechaInicio.toISOString());
        }
        if (fechaFin) {
            params.append('fechaFin', fechaFin.toISOString());
        }
        
        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        HttpCliente.get(url, {
            headers: { "Authorization": `Bearer ${token}`,'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_comediante_${comedianteId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe:', error);
            reject("Error al descargar el informe");
        });
    });
};

/**
 * GET method - Descarga el informe solo de videos de un comediante
 */
export const descargarInformeVideos = (comedianteId, fechaInicio = null, fechaFin = null, token) => {
    return new Promise((resolve, reject) => {
        let url = `/Estadisticas/videos/${comedianteId}/pdf`;
        
        const params = new URLSearchParams();
        if (fechaInicio) {
            params.append('fechaInicio', fechaInicio.toISOString());
        }
        if (fechaFin) {
            params.append('fechaFin', fechaFin.toISOString());
        }
        
        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        HttpCliente.get(url, {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_videos_${comedianteId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe de videos:', error);
            reject("Error al descargar el informe de videos");
        });
    });
};

/**
 * GET method - Descarga el informe solo de eventos de un comediante
 */
export const descargarInformeEventos = (comedianteId, fechaInicio = null, fechaFin = null, token) => {
    return new Promise((resolve, reject) => {
        let url = `/Estadisticas/eventos/${comedianteId}/pdf`;
        
        const params = new URLSearchParams();
        if (fechaInicio) {
            params.append('fechaInicio', fechaInicio.toISOString());
        }
        if (fechaFin) {
            params.append('fechaFin', fechaFin.toISOString());
        }
        
        if (params.toString()) {
            url += `?${params.toString()}`;
        }

        HttpCliente.get(url, {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_eventos_${comedianteId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe de eventos:', error);
            reject("Error al descargar el informe de eventos");
        });
    });
};

/**
 * GET method - Descarga el informe de un video específico
 */
export const descargarInformeVideoEspecifico = (videoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Estadisticas/video/${videoId}/pdf`, {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_video_${videoId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe del video:', error);
            reject("Error al descargar el informe del video");
        });
    });
};

/**
 * GET method - Descarga el informe de un evento específico
 */
export const descargarInformeEventoEspecifico = (eventoId, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Estadisticas/evento/${eventoId}/pdf`, {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_evento_${eventoId}_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe del evento:', error);
            reject("Error al descargar el informe del evento");
        });
    });
};

/**
 * GET method - Descarga el informe comparativo general
 */
export const descargarInformeComparativo = (token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Estadisticas/comparativa/pdf", {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_comparativo_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe comparativo:', error);
            reject("Error al descargar el informe comparativo");
        });
    });
};

/**
 * GET method - Descarga el informe general de la plataforma
 */
export const descargarInformeGeneral = (token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Estadisticas/general/pdf", {
            headers: { "Authorization": `Bearer ${token}`, 'accept': 'application/pdf' },
            responseType: 'blob'
        })
        .then(response => {
            const fileName = `informe_general_${new Date().toISOString().split('T')[0]}.pdf`;
            downloadPDF(response, fileName);
            resolve(true);
        })
        .catch(error => {
            console.error('Error al descargar informe general:', error);
            reject("Error al descargar el informe general");
        });
    });
};